import React, { useState, useContext, useEffect, useMemo } from 'react';
import get from 'lodash/get';
import { BodyText, DropdownMenu } from '@paypalcorp/pp-react';
import CopyToClipboard from '../../../../components/CopyToClipboard';
import IntegrationPageSectionContext from '../../StateManagement/IntegrationPageSectionContext';
import styles from '../TestCards.module.less';
import { trackFieldFocus, trackFieldChange } from '../../../../lib/fpti';

const ThreeDTestCards = () => {
  const { ThreeDsCards = {} } = useContext(IntegrationPageSectionContext);
  const [selectedCountry, setSelectedCountry] = useState('United States');
  const [selectedScenario, setSelectedScenario] = useState('');
  const [cards, setCards] = useState([]);

  const countryOptions = useMemo(() => {
    return (
      (ThreeDsCards.countries &&
        ThreeDsCards.countries.map((country) => ({
          label: country.PrimaryText,
          value: country.value
        }))) ||
      []
    );
  }, [ThreeDsCards.countries]);

  const scenarioOptions = useMemo(() => {
    return (
      (ThreeDsCards.scenarios &&
        ThreeDsCards.scenarios[selectedCountry]?.map((scenario) => ({
          label: scenario.primaryText,
          value: scenario.value
        }))) ||
      []
    );
  }, [selectedCountry, ThreeDsCards.scenarios]);

  useEffect(() => {
    const scenarios = get(ThreeDsCards, `scenarios.${selectedCountry}`, []);
    if (scenarios.length > 0) {
      const initialScenario = get(scenarios, '[0].value', '');
      setSelectedScenario(initialScenario);
      const initialCards = get(
        scenarios.find((scenario) => scenario.value === initialScenario),
        'cards',
        []
      );
      setCards(initialCards);
    }
  }, [ThreeDsCards, selectedCountry]);

  const handleCountryChange = (e) => {
    const newCountry = e.target.value;
    setSelectedCountry(newCountry);
    trackFieldFocus('Country');
    trackFieldChange(newCountry);

    const scenarios = get(ThreeDsCards, ['scenarios', newCountry], []);
    const newSelectedScenario = get(scenarios, [0, 'value'], '');
    setSelectedScenario(newSelectedScenario);

    const newCards = get(
      scenarios.find((scenario) => scenario.value === newSelectedScenario),
      'cards',
      []
    );
    setCards(newCards);
  };

  const handleScenarioChange = (e) => {
    const newScenario = e.target.value;
    setSelectedScenario(newScenario);
    trackFieldFocus('Scenario');
    trackFieldChange(newScenario);

    const updatedCards =
      ThreeDsCards.scenarios[selectedCountry]?.find((scenario) => scenario.value === newScenario)
        ?.cards || [];
    setCards(updatedCards);
  };

  return (
    <BodyText as="div">
      <div className={styles.dropdownmenu_wrapper}>
        <DropdownMenu
          id="countryDropdown"
          label="Country"
          options={countryOptions}
          value={selectedCountry}
          onChange={handleCountryChange}
          className={styles.dropdownmenu}
        />
        <DropdownMenu
          id="scenarioDropdown"
          label="Scenario"
          options={scenarioOptions}
          value={selectedScenario}
          onChange={handleScenarioChange}
          className={styles.dropdownmenu}
        />
      </div>
      <div className={styles.test_cards_section_threeds}>
        {cards
          ? cards.map((card) => (
              <div className={styles.card} key={card.number}>
                <span className={styles.card_brand}>{card.brand}</span>
                <span className={styles.card_number}>{card.number}</span>
                <CopyToClipboard contentToCopy={card.number} />
              </div>
            ))
          : null}
        {ThreeDsCards && ThreeDsCards.additionaltestcardslink && (
          <div className={styles.view_all}>
            <a href={ThreeDsCards.additionaltestcardslink} rel="noreferrer">
              View all test cards
            </a>
          </div>
        )}
      </div>
    </BodyText>
  );
};

export default ThreeDTestCards;
